var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_426_7107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0C5.5 0 5.77588 2.83247 6.85045 4.0145C7.92503 5.19654 10.5 5.5 10.5 5.5C10.5 5.5 7.92503 5.80346 6.85045 6.9855C5.77588 8.16753 5.5 11 5.5 11C5.5 11 5.22412 8.16753 4.14955 6.9855C3.07497 5.80346 0.5 5.5 0.5 5.5C0.5 5.5 3.07497 5.19654 4.14955 4.0145C5.22412 2.83247 5.5 0 5.5 0Z",
    fill: "#95B1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8C11 8 11.1931 10.06 11.9453 10.9196C12.6975 11.7793 14.5 12 14.5 12C14.5 12 12.6975 12.2207 11.9453 13.0804C11.1931 13.94 11 16 11 16C11 16 10.8069 13.94 10.0547 13.0804C9.30248 12.2207 7.5 12 7.5 12C7.5 12 9.30248 11.7793 10.0547 10.9196C10.8069 10.06 11 8 11 8Z",
    fill: "#95B1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 1C14 1 14.1379 2.54498 14.6752 3.18973C15.2125 3.83447 16.5 4 16.5 4C16.5 4 15.2125 4.16553 14.6752 4.81027C14.1379 5.45502 14 7 14 7C14 7 13.8621 5.45502 13.3248 4.81027C12.7875 4.16553 11.5 4 11.5 4C11.5 4 12.7875 3.83447 13.3248 3.18973C13.8621 2.54498 14 1 14 1Z",
    fill: "#95B1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_426_7107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLights);
export default __webpack_public_path__ + "static/media/lights.a7ccf835a752b992ac1544d6f3ad0a47.svg";
export { ForwardRef as ReactComponent };